"use strict";
export { NumberInputContext, NumberInputControl, NumberInputDecrementTrigger, NumberInputIncrementTrigger, NumberInputInput, NumberInputLabel, NumberInputPropsProvider, NumberInputRoot, NumberInputRootProvider, NumberInputScrubber, NumberInputValueText, useNumberInputStyles } from './number-input.js';
export { useNumberInput, useNumberInputContext } from '@ark-ui/react/number-input';
import * as namespace from './namespace.js';
export { namespace as NumberInput };
